// VITE_API_URL must be set to the full backend API base, e.g. https://api.your-domain.com/api
// In local dev it falls back to /api which the Vite proxy forwards to the backend container.
export const API_URL = (import.meta.env.VITE_API_URL || '/api').replace(/\/$/, '')

// Strip the trailing /api to get the backend root (used for storage asset URLs)
export const BACKEND_URL = API_URL.endsWith('/api') ? API_URL.slice(0, -4) : ''

export const resolveBackendUrl = (path = '') => {
    if (!path) return BACKEND_URL
    if (/^https?:\/\//i.test(path)) return path
    const normalizedPath = path.startsWith('/') ? path : `/${path}`
    return BACKEND_URL ? `${BACKEND_URL}${normalizedPath}` : normalizedPath
}

